import { LitElement, html, svg, css } from 'lit';
import { sharedStyles, stateOf } from './base.js';

// <gt-sparkline> — a tiny trend line, no chart library.
//   el.data = [1, 3, 2, 5, 4];   // reactive; re-renders in place (SSE-friendly)
// Colored by first->last trend unless `state` (up|down|flat) is forced.
export class GtSparkline extends LitElement {
  static properties = {
    data: { attribute: false },
    state: { type: String },
    w: { type: Number },
    h: { type: Number },
  };
  constructor() {
    super();
    this.data = [];
    this.w = 96;
    this.h = 28;
  }
  static styles = [
    sharedStyles,
    css`
      :host {
        display: inline-block;
        line-height: 0;
      }
      svg {
        display: block;
      }
      .up {
        stroke: var(--up, #22c55e);
      }
      .down {
        stroke: var(--down, #ef4444);
      }
      .flat {
        stroke: var(--muted, #94a3b8);
      }
    `,
  ];
  render() {
    const d = (this.data || []).map(Number).filter((n) => !Number.isNaN(n));
    const w = this.w,
      h = this.h,
      pad = 2;
    if (d.length < 2) return html`<svg width=${w} height=${h}></svg>`;
    const min = Math.min(...d),
      max = Math.max(...d);
    const span = max - min || 1;
    const step = (w - pad * 2) / (d.length - 1);
    const pts = d.map((v, i) => {
      const x = pad + i * step;
      const y = pad + (h - pad * 2) * (1 - (v - min) / span);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    });
    const st = this.state || stateOf(d[d.length - 1] - d[0]);
    return html`<svg width=${w} height=${h} viewBox="0 0 ${w} ${h}">
      ${svg`<polyline class=${st} points=${pts.join(' ')} fill="none" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round" />`}
    </svg>`;
  }
}
customElements.define('gt-sparkline', GtSparkline);
